<template>
<div>
	<h1 class="mb-2">Top products</h1>
	<div class="top-products-wrapper">
		<div class="top-products">
			<router-link class="top-product" v-for="(product, index) in topProducts" :key="index" :to="'product/' + product.id">
				<img :src="product.img" alt="">
			</router-link>
		</div>
	</div>
</div>
</template>

<script>
	export default {
		name: 'TopProducts',
		computed: {
			topProducts(){
				return this.$store.state.topProducts
			}	
		}
	}
</script>

<style>
.top-products-wrapper{
	height: 155px;
	width: 100%;
	overflow: scroll;
	margin-bottom: 30px;
}
.top-products{
	width: 1300px;
	height: 100%;
	display: flex;
	justify-content: space-between;
	animation: slidein 0.6s;
}
@keyframes slidein{
	0%{
		opacity: 0;
		transform: translateX(300px);
	}
	100%{
		opacity: 1;
		transform: translateX(0px);
	}
}
.top-product{
	display: inline-block;
	width: 100px;
	height: 150px;
	border-radius: 3px;
	overflow: hidden;
	box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
	transition: box-shadow 0.1s;
}
.top-product:hover{
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
.top-product img{
	height: 100%;
	width: 100%;
}
</style>